export default __webpack_public_path__ + "static/media/home-travel-agency-tour-type-img01.2a731630.jpg";